import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Urls } from '@/lib/navigation';
import {
  PAPER_CONTROL_RADIUS_CLASS,
  PAPER_ICON_COMPACT_CLASS,
  PAPER_ICON_STROKE_WIDTH,
} from './paperShapes';

type BackButtonProps = {
  className?: string;
};

export function BackButton({ className }: BackButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasHistory = location.key !== 'default';
  return (
    <button
      type="button"
      onClick={() => (hasHistory ? navigate(-1) : navigate(Urls.home()))}
      className={cn(
        'inline-flex items-center gap-[6px] h-[28px] px-[8px] cursor-pointer',
        PAPER_CONTROL_RADIUS_CLASS,
        'text-[11px] text-[var(--fg-3)] hover:text-[var(--fg)] transition-colors',
        className,
      )}
    >
      <ArrowLeft className={PAPER_ICON_COMPACT_CLASS} strokeWidth={PAPER_ICON_STROKE_WIDTH} />
      Back
    </button>
  );
}
